import { Reducer } from 'redux'
import { getType } from 'typesafe-actions'
import { createCiteProjectSuccess } from '@chegg-wt/core/state/folders/actions'
import { Order } from '@chegg-wt/core/globalTypes'
import { SortNames } from '@chegg-wt/core/state/projects/constants'
import { ProjectTypeKeys } from '@chegg-wt/core/constants/projectTypeKey'
import { starMatchingProject } from '@chegg-wt/core/utils/projects'
import { ActionTypes } from './constants'
import { Action, ProjectsState } from './types'

export const initialState = {
  currentProjects: [],
  order: Order.desc,
  sortName: SortNames.DATE,
  projectSearch: '',
  isLoading: false,
  filter: ProjectTypeKeys.ALL,
}

export const projectsReducer: Reducer<ProjectsState> = (
  state = initialState,
  action: Action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_PROJECTS:
      return {
        ...state,
        isLoading: true,
      }
    case ActionTypes.FETCH_PROJECTS_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        currentProjects: action.payload.projects,
      }
    case ActionTypes.FETCH_PROJECTS_ERROR:
      return {
        ...state,
        isLoading: false,
      }
    case ActionTypes.SEARCH_PROJECTS:
      return {
        ...state,
        isLoading: true,
        currentProjects: [],
        projectSearch: action.payload.searchValue,
        filter: ProjectTypeKeys.ALL,
      }
    case ActionTypes.SORT_PROJECTS:
      return {
        ...state,
        isLoading: true,
        currentProjects: [],
      }
    case ActionTypes.SET_PROJECT_FILTER:
      return {
        ...state,
        projectSearch:
          action.payload.filter === ProjectTypeKeys.SEARCHING ? state.projectSearch : '',
        filter: action.payload.filter,
      }
    case ActionTypes.STAR_PROJECT:
      return {
        ...state,
        currentProjects: starMatchingProject(
          state.currentProjects,
          action.payload.id,
          true
        ),
      }
    case ActionTypes.UNSTAR_PROJECT:
      return {
        ...state,
        currentProjects: starMatchingProject(
          state.currentProjects,
          action.payload.id,
          false
        ),
      }
    case ActionTypes.SET_ORDER:
      return {
        ...state,
        order: action.payload.order,
      }
    case ActionTypes.SET_SORT_NAME:
      return {
        ...state,
        order: action.payload.sortName === SortNames.NAME ? Order.asc : Order.desc,
        sortName: action.payload.sortName,
      }
    case getType(createCiteProjectSuccess):
      return {
        ...state,
        filter: ProjectTypeKeys.ALL,
      }
    default:
      return state
  }
}

export default projectsReducer
